<template>
  <button
    :disabled="props.loading || !props.buttonActive"
    :class="[
      'bg-error-50 hover:bg-danger-50 border-danger-100 text-danger-500 focus:ring-danger-500 flex w-full justify-center rounded-md border px-4  py-2 text-sm focus:outline-hidden focus:ring-2 focus:ring-offset-2',
      props.loading ? ['bg-danger-100 hover:bg-danger-100'] : '',
      !props.buttonActive ? ['bg-neutral-500 hover:bg-neutral-500'] : '',
    ]"
    :data-test="'TButtonFull-' + props.dataTestName"
    @click="props.action"
  >
    <TIcon
      v-if="props.loading"
      name="loader"
      class="mr-2 h-5 w-5 animate-spin"
    />
    <span v-if="!props.loading">
      <slot />
    </span>
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  loading: { type: Boolean, required: false, default: false },
  action: { type: Function, required: false, default: null },
  buttonActive: { type: Boolean, required: false, default: true },
  dataTestName: { type: String, required: false, default: '' },
});
</script>
